import { render, staticRenderFns } from "./IcmsCargaLiquida.vue?vue&type=template&id=1328ad56&scoped=true&"
import script from "./IcmsCargaLiquida.vue?vue&type=script&lang=js&"
export * from "./IcmsCargaLiquida.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328ad56",
  null
  
)

export default component.exports